<template>
  <div class="betslipHistory">
    <LastTickets :isBallDrawn="isBallDrawn" :productNameLabel="productNameLabel"/>
  </div>
</template>

<script>
import LastTickets from '../../BetslipArea/LastTickets/LastTicketsWrapper';

export default {
  name: 'BetslipHistory',
  props: {
    isBallDrawn: {
      type: Function,
      default: undefined,
    },
    productNameLabel: {
      type: String,
      default: '',
    },
  },
  components: {
    LastTickets,
  },
};
</script>

<style lang="scss" scoped>
.betslipHistory {
  position: relative;
  z-index: 99;
}
</style>
